import { render } from "./ProcurementForm.vue?vue&type=template&id=0ed6ea46"
import script from "./ProcurementForm.vue?vue&type=script&lang=js"
export * from "./ProcurementForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__